module.exports = __webpack_public_path__ + "img/values-1.3b7653d6.jpg";